import { DescriptionField, descriptionFieldCopy } from "@/components/ListingFields/DescriptionField";
import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";

const LISTING_TYPE = "product" as const;

export interface ProductDescriptionEditorProps {
  /** Field error for the description, or undefined when valid. */
  error?: string;
  /** Called with the new HTML on every change. */
  onChange: (html: string) => void;
  /** Current description, as HTML. */
  value: string;
}

export function ProductDescriptionEditor({ error, onChange, value }: ProductDescriptionEditorProps) {
  return (
    <EditorSection {...descriptionFieldCopy(LISTING_TYPE)}>
      <DescriptionField error={error} listingType={LISTING_TYPE} onChange={onChange} value={value} />
    </EditorSection>
  );
}
